export const locale = {
    lang: 'pl',
    data: {
        "Date range": "Zakres dat",
        "Start date": "Od dnia",
        "End date": "Do dnia",
        "Yesterday": "Wczoraj",
        "Today": "Dzisiaj",
        "Last week": "Ostatni tydzień",
        "Last month": "Ostatni miesiąc",
        "Reports": "Raporty",
        "The report data by time period": "Raport dla okresu",
    }
};
